/* First trigger wins: newsletter at 11 seconds OR 60% scroll; desktop top-edge exit shows the exit offer. One automatic display per session. Never opens over another open dialog; it retries when that dialog closes. */
(()=>{'use strict';
const dlg=document.getElementById('ZFPopup');
if(!dlg||typeof dlg.showModal!=='function')return;
const KEY='zf-signup-popup', SESSION_KEY='zf-signup-popup-shown';
const cfg={delay:+dlg.dataset.delay||11000,scroll:+dlg.dataset.scroll||60,days:+dlg.dataset.dismissDays||14};
const read=()=>{try{return JSON.parse(localStorage.getItem(KEY))}catch{return null}};
const write=state=>{try{localStorage.setItem(KEY,JSON.stringify({state,at:Date.now()}))}catch{}};
const params=new URLSearchParams(location.search);
const preview=params.get('zf_popup');
const forced=preview==='1'||preview==='newsletter'||preview==='exit';
const seen=read();
let sessionSeen=false;try{sessionSeen=sessionStorage.getItem(SESSION_KEY)==='1';}catch{}
if(!forced&&(sessionSeen||(seen&&(seen.state==='subscribed'||Date.now()-seen.at<cfg.days*864e5))))return;

const form=dlg.querySelector('#ZFPopupForm'), email=dlg.querySelector('#ZFPopupEmail'), submit=dlg.querySelector('[data-zf-popup-submit]');
const errorBox=dlg.querySelector('[data-zf-popup-error]'), formView=dlg.querySelector('[data-zf-popup-form-view]'), doneView=dlg.querySelector('[data-zf-popup-done]');
const art=dlg.querySelector('.zf-popup-art img[data-src]');
const newsletterArt=art?{src:art.dataset.src,alt:art.alt,width:art.width,height:art.height}:null;
const status=text=>{const el=document.getElementById('ZFStatus');if(el)el.textContent=text;};
const fields={kicker:formView.querySelector('.zf-popup-kicker'),heading:dlg.querySelector('#ZFPopupTitle'),body:dlg.querySelector('#ZFPopupText'),button:submit,fine:dlg.querySelector('#ZFPopupFine')};
const newsletterCopy=Object.fromEntries(Object.entries(fields).map(([key,el])=>[key,el.textContent]));
let exitCopy=null;try{exitCopy=JSON.parse(dlg.querySelector('[data-zf-popup-exit-copy]').textContent);}catch{}
let armed=true, subscribed=false, busy=false, timer;
const startedAt=Date.now();

/* Fetch the graphic once the page has settled so it is ready when the pop-up opens. */
const preload=()=>{if(art&&!art.src)art.src=art.dataset.src;};
if(document.readyState==='complete')setTimeout(preload,1200);else addEventListener('load',()=>setTimeout(preload,1200),{once:true});

function disarm(){armed=false;clearTimeout(timer);removeEventListener('scroll',onScroll);document.removeEventListener('mouseout',onLeave);document.removeEventListener('visibilitychange',onVisible);document.removeEventListener('close',onOtherDialogClose,true);}
function open(variant='newsletter'){
  if(!armed||document.hidden)return;
  if(document.querySelector('dialog[open]'))return;
  const copy=variant==='exit'&&exitCopy?exitCopy:newsletterCopy;
  for(const [key,el] of Object.entries(fields))el.textContent=copy[key];
  dlg.dataset.variant=variant;
  if(art&&newsletterArt){
    const exitArt=variant==='exit'&&art.dataset.exitSrc;
    art.dataset.src=exitArt?art.dataset.exitSrc:newsletterArt.src;
    art.src=art.dataset.src;
    art.removeAttribute('srcset');
    art.alt=exitArt?art.dataset.exitAlt:newsletterArt.alt;
    art.width=exitArt?+art.dataset.exitWidth:newsletterArt.width;
    art.height=exitArt?+art.dataset.exitHeight:newsletterArt.height;
  }
  disarm();preload();dlg.showModal();
  if(!forced){try{sessionStorage.setItem(SESSION_KEY,'1');}catch{}}
}
function onScroll(){
  const room=document.documentElement.scrollHeight-innerHeight;
  if(room>0&&scrollY/room*100>=cfg.scroll)open('newsletter');
}
function onLeave(e){
  if(!e.relatedTarget&&e.clientY<=0)open('exit');
}
function onVisible(){if(document.hidden)return;if(Date.now()-startedAt>=cfg.delay)open('newsletter');else onScroll();}
/* A size guide, product details or zoom dialog blocked a trigger: re-check once it closes. */
function onOtherDialogClose(e){if(e.target===dlg||!(e.target instanceof HTMLDialogElement))return;setTimeout(onVisible,400);}
timer=setTimeout(()=>open('newsletter'),cfg.delay);
addEventListener('scroll',onScroll,{passive:true});
document.addEventListener('visibilitychange',onVisible);
document.addEventListener('close',onOtherDialogClose,true);
if(matchMedia('(hover:hover) and (pointer:fine)').matches)document.addEventListener('mouseout',onLeave);

dlg.addEventListener('click',e=>{
  if(e.target.closest('[data-zf-popup-close]')){dlg.close();return;}
  if(e.target===dlg&&!(email&&email.value.trim()))dlg.close(); /* outside tap; an unfinished email is protected */
});
dlg.addEventListener('close',()=>{if(!forced)write(subscribed?'subscribed':'dismissed');});

function showError(text){errorBox.textContent=text;errorBox.hidden=false;}
form.addEventListener('submit',async e=>{
  e.preventDefault();
  if(busy)return;
  errorBox.hidden=true;
  if(!email.checkValidity()){showError('That email does not look right. Check it and try again.');email.focus();return;}
  busy=true;submit.disabled=true;
  try{
    const res=await fetch(form.action,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'text/html'}});
    if(/\/challenge/.test(res.url)){form.submit();return;} /* Shopify wants a captcha: hand the form over natively */
    if(res.ok&&/customer_posted=true/.test(res.url)){
      subscribed=true;write('subscribed');
      formView.hidden=true;doneView.hidden=false;
      doneView.querySelector('[data-zf-popup-done-title]').focus();
      status('You are on the list. Check your inbox for your welcome gift.');
    }else showError('That did not go through. Check the email and try again.');
  }catch{showError('Something interrupted that. Try once more, or use the signup at the bottom of the page.');}
  finally{busy=false;submit.disabled=false;}
});

if(forced)open(preview==='exit'?'exit':'newsletter');
})();
